module.exports = {"label":{"client":"Client","inactive":"Inactive Clients"},"validation":{"client":{"required":"Please select a client"}}}